
window.addEventListener('error',function(e){

if( e.target.tagName.toUpperCase() === 'IMG' ){

}
},true)

import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import {userBindRefereeIdApi} from './axios/api';
import { mapState, mapActions } from 'vuex'
export default {
name: 'app',
data(){
return{
entryUrl: document.location.href,
isDemo:false,
}
},
created() {
let search = location.search;
let searchObj = {};
if(search) {
search = decodeURIComponent(location.search);
if(search[0] === '?') search = search.substring(1);
if(search[search.length -1] === '=') search = search.substring(0, search.length -1);
let searchArr = search.split('&');
searchArr.map(item => {
const arr = item.split('=');
searchObj[arr[0]] = arr[1];
})
}
const {user_id, from,isCar, token, auth_user_id,invite_code} = searchObj;
if(auth_user_id && token) {
window.localStorage.setItem('auth_user_id', auth_user_id);
}
if(this.client == 1){

}
if(user_id && this.client == 1){
sessionStorage.setItem('user_id', user_id);
userBindRefereeIdApi(user_id).then(res => {
})
}
if(invite_code && this.client == 1){
userBindRefereeIdApi(invite_code).then(res => {
})
}
if(token) {
window.localStorage.setItem('token', token);
var p = window.location.origin + window.location.pathname
var url = window.location.search
var strs,local =  window.location.pathname == '/' ?'?check=true&': '?check=true&'
var thisParam = new Object();
if (url.indexOf("?") != -1) {
var str = url.substr(1);
strs = str.split("&");
for(var i = 0; i < strs.length; i ++) {
thisParam[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
}
setTimeout(function () {
if(thisParam.token){
for(i in thisParam){
if(i != 'token' && i!='auth_user_id' && i && thisParam[i]){
local =  local + i + '=' + thisParam[i] +'&'
}
}
setTimeout(function () {
window.location.href = p + local
},200)
}
},10)
}
}
},
components: {
Tabbar,
TabbarItem,
},
computed: {
...mapState({
route: state => state.route,
path: state => state.route.path,
deviceready: state => state.app.deviceready,
demoTop: state => state.vux.demoScrollTop,
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction,
client: state => state.client,
}),
viewTransition () {
if (!this.direction) return ''
return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
},
isShowBar(){
return this.$route.meta.tab || false
},
},

}



// WEBPACK FOOTER //
// ./src/App.vue